import { css } from '@emotion/css';

import { AlignItems, BaseStyle, Color, Display, Font, FontWeight, Spacing } from '../../../../styles';

export const cardWrapper = css`
  background: ${Color.Gray1};
  box-shadow: 0rem 0.125rem 0.25rem rgba(2, 85, 163, 0.25);
  border-radius: 0.5rem;
  ${BaseStyle.clip}
  width: 100%;
  &:hover {
    box-shadow: 0 4px 12px 0 rgba(2, 85, 163, 0.25);
  }
  .ant-card-cover {
    ${BaseStyle.clip}
    width: 100%;
    ${BaseStyle.relative}
  }
  .ant-card-body {
    ${Spacing.p16}
  }
  .ant-card-meta-title {
    white-space: normal;
    ${Font.md}
  }
`;

export const offerName = css`
  ${Font.h6}
  ${FontWeight.semibold}
  color: ${Color.Gray10};
  word-break: break-all;
  min-height: 4rem;
`;

export const offerSubDetails = css`
  color: ${Color.Gray7};
`;

export const offerSectionContainer = css`
  ${Spacing.mt24}
`;

export const minimalInvestment = css`
  ${Font.lg}
  ${FontWeight.bold}
  color: ${Color.Orange6};
`;

export const totalCapitalRaised = css`
  ${Font.lg}
  ${FontWeight.bold}
  color: ${Color.Brand6};
`;

export const offerImage = css`
  ${BaseStyle.relative}
  aspect-ratio: 16/9;
`;

export const indicationLogo = css`
  font-size: 0.8125rem;
  color: ${Color.Green8};
  ${Spacing.mr4}
  font-weight: 400;
`;

export const offerTags = css`
  left: 1rem;
  bottom: 0;
  position: absolute;
  width: 100%;
`;

// Note: duplicateed styles
export const accreditedInvestorsOnly = css`
  ${Display.flex}
  ${AlignItems.center}
`;

// Note: duplicateed styles
export const accreditedInvestorsOnlyText = css`
  ${Spacing.mr4}
`;
